import { ReactNode } from "react";

export type MenuName = "menuAnalytics" | "menuWidgetLibrary"; // add more menus here

export enum AnalyticsSubMenu {
  Overview = "dashboard/overview",
  Profit = "dashboard/profit",
  Revenue = "dashboard/revenue",
  Shipping = "dashboard/shipping",
  Visitors = "dashboard/visitors",
  Orders = "dashboard/orders",
  Discounts = "dashboard/discounts",
  ProductGroups = "dashboard/product-groups",
  Trend = "dashboard/trend",
  StatSig = "dashboard/statSig",
  Subscriptions = "dashboard/subscriptions",
  DataReconciliation = "dashboard/data-reconciliation",
}

export enum WidgetsSubMenu {
  Sitewide = "widget-library/sitewide",
  Campaign = "widget-library/experiences",
}

export interface BaseRoute {
  path: string;
  sidebarName: string;
  component: ReactNode;
  icon: any;
}

export interface MainRoute extends BaseRoute {
  routes: BaseRoute[];
}
